<template>
  <span class="language-flag d-inline-flex align-center">
    <img
      v-if="showFlag"
      :src="flagSrc"
      :alt="code"
      width="20"
      height="15"
      class="lang-flag-img mr-1"
      loading="lazy"
      @error="showFlag = false"
    />
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
/**
 * Cross-platform language/flag display.
 * Uses flag images (FlagCDN) instead of Unicode emoji so flags show on Windows
 * and other devices where system fonts don't include flag glyphs.
 */
const FLAG_CDN = "https://flagcdn.com/w20";
const CODE_TO_ISO = {
  en: "gb",
  la: "la",
  lo: "la",
  th: "th",
  cn: "cn",
  ch: "cn",
  zh: "cn",
};

export default {
  name: "LanguageFlag",
  props: {
    code: { type: String, required: true },
    label: { type: String, default: "" },
  },
  data() {
    return {
      showFlag: true,
    };
  },
  computed: {
    flagSrc() {
      const iso = CODE_TO_ISO[this.code.toLowerCase()] || this.code.toLowerCase();
      return `${FLAG_CDN}/${iso}.png`;
    },
  },
};
</script>

<style scoped>
.lang-flag-img {
  object-fit: contain;
  vertical-align: middle;
}
</style>
